import { gql } from '@apollo/client';
import FACILITY_DETAIL_FRAGMENT from '../fragments/facilityDetailFagment';

const FACILITY_DETAIL_QUERY = gql`
  query facilityDetail($id: ID!) {
    facility(id: $id) {
      ...FacilityDetailFragment
    }
  }

  ${FACILITY_DETAIL_FRAGMENT}
`;

export default FACILITY_DETAIL_QUERY;
